<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <ValidatableTextField v-model:form="form" label="Name *" :field="'name'" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.steward_id" v-model:form="form" :field-name="'steward_id'" :items="stewards" :loading="fetchingStewards" label="Steward *" />
            </v-col>
            <v-col cols="12">
                <DatePicker v-model:field="form.date" v-model:form="form" label="Event Date" :field-name="'date'" />
            </v-col>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" type="number" label="Payout price/tCO2e" min="0" step="any" :field="'payout_price'" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="props.item.currency" label="Currency" variant="outlined" disabled />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import type { IPayoutEvent } from '../../models/PayoutEvent';
import { usePayoutEventRepository } from '../../repositories/usePayoutEventRepository';
import { useStewardRepository } from '@app/land-hold/steward/repositories/useStewardRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<IPayoutEvent>,
        required: true,
    },
});

const store = usePayoutEventRepository().command.store(props.item);
const form = store.form;
useInjectSubmitForm(store.execute);

const { stewards, fetchingStewards } = useStewardRepository().query.list();
</script>
